export const SEVEN_DAYS: number = 7;
export const ONE_DAY: number = 1;
export const WEEK_START: number = 1;
